import { api } from '@/core/api/';
import utils from '@/utils/utilities';

const URL = 'api/documents';

export const downloadDocumentByAttachmentId = async (attachmentId) => {
  utils.convertToBlob((await api.get(`${URL}/${attachmentId}`)).data);
};

export const downloadDocumentByAttachment = (attachment) => {
  let reader = new FileReader();
  reader.readAsDataURL(attachment);
  reader.onloadend = () => {
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const url = reader.result;
    a.href = url;
    a.download = attachment.name;
    a.click();
    window.URL.revokeObjectURL(url);
  };
};
